import { AllocateSingleId } from "../AllocateId";
import { GetMasterTableEntries } from "../GetMasterTableEntries";
import { DeleteFromServer, FetchFromServer, SaveToServer } from "../Post";

const MasterTableName = "GladianceDepartmentMaster";
const FetchRequestType = "GladianceDepartmentFetchRequest";

export const GetGladianceDepartment = async (Ref) => {
  let payload = { GladianceDepartmentRefs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let resultList = GetMasterTableEntries(td, MasterTableName);
  if (resultList.length > 0) {
    return resultList[0];
  }
  return null;
};

export const SaveGladianceDepartment = async (
  ref,
  payload,
  images
) => {
  payload["Ref"] = await AllocateSingleId(ref);
  return await SaveToServer(payload, MasterTableName, images);
};

export const DeleteGladianceDepartment = async (payload) => {
  return await DeleteFromServer(payload, MasterTableName);
};

export const GetGladianceDepartmentList = async () => {
  let payload = { GladianceDepartmentRefs: [] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  result = result.sort((a, b) => a.Name.localeCompare(b.Name));
  return result;
};

